import * as Yup from 'yup';

export const CreateOrEditExpenseSchema = Yup.object().shape({
  name: Yup.string().required('You must enter a expense name'),
  type: Yup.string()
    .optional()
    .nullable()
    .matches(/^(SCALES|TOLLS|TRUCK_PARTS|TRUCK_WASH|OTHER)$/, 'Invalid type'),
  classification: Yup.string()
    .required('You must enter a expense classification')
    .matches(/^(DEDUCT_FROM_PAY|REIMBURSE|COMPANY_CHARGE)$/, 'Invalid classification'),
  equipment_id: Yup.string().optional(),
  driver_id: Yup.string().optional(),
  trip_id: Yup.string().optional().nullable(),
  frequency: Yup.string()
    .required('You must enter a frequency')
    .matches(/^(WEEKLY|ONE_TIME)$/, 'Invalid frequency'),
  date_from: Yup.date()
    .typeError('You must enter a date from')
    .required('You must enter a date from'),
  date_to: Yup.date()
    .when('frequency', {
      is: 'WEEKLY',
      then: Yup.date()
        .typeError('You must enter a date to when frequency is weekly')
        .required('You must enter a date to when frequency is weekly'),
      otherwise: Yup.date().optional().nullable()
    })
    .min(Yup.ref('date_from'), 'Date to must be after Date from'),
  amount: Yup.number()
    .typeError('You must enter an amount')
    .required('You must enter an amount')
    .min(0, 'Amount must be greater than 0')
});
